"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const strings_1 = require("../../../constants/strings");
const codingQuery_1 = require("../../../queries/codingQuery");
const companyQuery_1 = require("../../../queries/companyQuery");
const userQuery_1 = require("../../../queries/userQuery");
const zustandStore_1 = require("../../../zustandStore");
const navigationPanel_1 = __importDefault(require("./navigationPanel"));
const teamInfo_1 = __importDefault(require("./teamInfo"));
const SelectRoleAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('../../templates/teamSettings/people/selectRoleAside'))));
const AddDefaultManagerAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./addDefaultManagerAside'))));
const UserDetailsAside = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./userDetailsAside'))));
const AddPeople = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./addPeople'))));
const CodingList = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./codingList'))));
const CreateTeamModal = ({ closeCreateTeamModal }) => {
    const { data: codingLists = [] } = (0, react_query_1.useQuery)((0, codingQuery_1.getCodingListsQuery)({ skipDisabled: true }));
    const step = (0, zustandStore_1.useZustand)(state => state.modal?.team?.step);
    const isModalOpen = (0, zustandStore_1.useZustand)(state => state.modal?.team?.isOpen);
    const theme = (0, material_1.useTheme)();
    const { setPageLoading } = (0, zustandStore_1.useZustand)();
    const { data: userData } = (0, react_query_1.useQuery)(userQuery_1.userQuery);
    const { data: companyPropertiesData } = (0, react_query_1.useQuery)((0, companyQuery_1.companyPropertiesQuery)(userData?.companyAccountId, {
        cardprovider: 'tsgo-cardprovider',
    }));
    const cardProvider = companyPropertiesData?.cardprovider;
    const isAmexCardProvider = cardProvider === 'AMEX';
    (0, react_1.useEffect)(() => {
        setPageLoading(false);
    }, [setPageLoading]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { "data-testid": "createTeamModal", style: { position: 'absolute', inset: '0 0 60px 0', backgroundColor: theme.palette.tsGoColor.white }, children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { paddingTop: 1, paddingRight: 2, paddingBottom: 1, paddingLeft: 2, display: 'flex', flexDirection: 'row' }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { "ts-variant": "title", children: strings_1.companySettingsTeamsStrings.CREATE_TEAM_TITLE }), (0, jsx_runtime_1.jsx)(material_1.IconButton, { "aria-label": "close", onClick: () => closeCreateTeamModal(isModalOpen), sx: {
                            position: 'absolute',
                            right: theme.tsGoUnit.tsUnit,
                            padding: 0,
                        }, children: (0, jsx_runtime_1.jsx)(Close_1.default, {}) })] }), (0, jsx_runtime_1.jsx)(navigationPanel_1.default, { step: step }), (0, jsx_runtime_1.jsx)(material_1.Box, { sx: { height: '100%', overflowY: 'auto', overflowX: 'hidden', backgroundColor: 'hsl(200, 21%, 92%)' }, children: (0, jsx_runtime_1.jsx)("div", { className: step === 2 && codingLists.length > 0 ? '' : 'modal-panel-content content', children: step === 0 ? ((0, jsx_runtime_1.jsx)(teamInfo_1.default, { closeCreateTeamModal: closeCreateTeamModal })) : step === 1 ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(SelectRoleAside, {}) }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(AddDefaultManagerAside, {}) }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(UserDetailsAside, {}) }), (0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(AddPeople, {}) })] })) : isAmexCardProvider ? ((0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(material_1.Stack, { sx: {
                                p: 2,
                            }, children: (0, jsx_runtime_1.jsx)(CodingList, {}) }) })) : null }) })] }));
};
exports.default = CreateTeamModal;
